/* global require */
import Vue from "vue";

export default Vue.component("tab-button", {
  props: [ "value", "name", "title" ],

  data() {
    return {};
  },

  computed: {
    open() {
      return this.value == this.name;
    }
  },

  template: require("./templates/tab-button.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/tab-button.js